<template>
  <div class="course-create-wrap">
    <a-form  :form="form">
      <a-card :bordered="false" style="box-shadow:0px 1px 10px 0px rgba(0,0,0,0.06);">
        <div class="info-title">
          收货信息
        </div>
        <div class="info-content" style="padding-top:25px;">
          <a-row >
            <a-col :span="24">
              <a-form-item
                style="margin-bottom:12px;"
                :label-col="{ span: 2 }"
                :wrapper-col="{ span: 14 }"
                label="收货人    ">
                <a-input 
                    placeholder="请输入收货人"  
                    disabled
                    v-decorator="[
                    'receiverName'
                    ,{'initialValue':this.receiverName}
                  ]"/>
                <!-- <span class="leave-num-count"></span> -->
              </a-form-item>
            </a-col>
          </a-row>
          <a-row >
            <a-col :span="24">
              <a-form-item
                style="margin-bottom:12px;"
                :label-col="{ span: 2 }"
                :wrapper-col="{ span: 14 }"
                label="手机号    ">
                <a-input
                  placeholder="请输入手机号"
                  disabled
                  v-decorator="[
                    'receiverPhone'
                    ,{'initialValue':this.receiverPhone}
                  ]" />
              </a-form-item>
            </a-col>
          </a-row>

          <a-row >
            <a-col :span="24">
              <a-form-item
                style="margin-bottom:12px;"
                :label-col="{ span: 2 }"
                :wrapper-col="{ span: 14 }"
                label="收货地址    ">
                <a-input
                  placeholder="请输入收货地址"
                  disabled
                  v-decorator="[
                    'receiverAdress'
                    ,{'initialValue':this.receiverAdress}
                  ]" />
              </a-form-item>
            </a-col>
          </a-row>
        </div>
      </a-card>

      <a-card :bordered="false" style="box-shadow:0px 1px 10px 0px rgba(0,0,0,0.06);">
        <div class="info-title">
          发货信息
        </div>
        <div class="info-content" style="padding-top:25px;">
          <a-row >
            <a-col :span="24">
              <a-form-item
                style="margin-bottom:12px;"
                :label-col="{ span: 2 }"
                :wrapper-col="{ span: 14 }"
                label="订单号   ">
                <a-input 
                    placeholder="请输入订单号"  
                    disabled
                    v-decorator="[
                    'orderNo',
                    {rules: [{ required: true, message: '请输入订单号' }]}
                    ,{'initialValue':this.orderNo}
                  ]"/>
                <!-- <span class="leave-num-count"></span> -->
              </a-form-item>
            </a-col>
          </a-row>
          <a-row >
            <a-col :span="24">
              <a-form-item
                style="margin-bottom:12px;"
                :label-col="{ span: 2 }"
                :wrapper-col="{ span: 14 }"
                label="快递公司   ">
                <a-input
                  placeholder="请输入快递公司"
                  v-decorator="[
                    'logisticsName',
                    {rules: [{ required: true, message: '请输入快递公司' }]}
                    ,{'initialValue':this.logisticsName}
                  ]" />
              </a-form-item>
            </a-col>
          </a-row>

          <a-row >
            <a-col :span="24">
              <a-form-item
                style="margin-bottom:12px;"
                :label-col="{ span: 2 }"
                :wrapper-col="{ span: 14 }"
                label="快递单号   ">
                <a-input
                  placeholder="请输入快递单号"
                  v-decorator="[
                    'logisticsNo',
                    {rules: [{ required: true, message: '请输入快递单号' }]}
                    ,{'initialValue':this.logisticsNo}
                  ]" />
              </a-form-item>
            </a-col>
          </a-row>
        </div>
      </a-card>
      <a-card :bordered="false" style="text-align:center;padding:14px 0px;box-shadow:0px 1px 10px 0px rgba(0,0,0,0.06);">
        <div class="a-row">
          <!-- <a-button
            style="text-align:center;width:232px;line-height:40px;height:40px;font-size:14px;"
            type="primary"
            html-type="submit"
          >
            发货
          </a-button> -->
          <a-button
            style="text-align:center;width:232px;line-height:40px;height:40px;font-size:14px;"
            type="primary"
            @click="sendOutOk()"
          >
            发货
          </a-button>
        </div>
      </a-card>

    </a-form>
  </div>
  
</template>

<script>

  // import moment from 'moment'
  // import pick from 'lodash.pick'
  // import { FormTypes } from '@/utils/JEditableTableUtil'
  // import { JEditableTableMixin } from '@/mixins/JEditableTableMixin'

  
  import {sendGoods,queryOrderById} from '@/api/api'


  export default {
    name: 'GoodsSendOut',
    components: { },
    mixins: [],
    data() {
      return {
        orderNo:"",
        logisticsName:"",
        logisticsNo:"0",
        receiverAdress:"",
        receiverName:"",
        receiverPhone:"",
        form: this.$form.createForm(this)
      }
    },
    methods: {
      getOrderById(){
      queryOrderById({id:this.id}).then((res)=>{

        if(res.success){
          
        this.receiverAdress = res.result.receiverAdress;
        this.receiverName = res.result.receiverName;
        this.receiverPhone = res.result.receiverPhone;
        this.$nextTick(() => {
          this.form.setFieldsValue({receiverAdress:this.receiverAdress})
          this.form.setFieldsValue({receiverName:this.receiverName})
          this.form.setFieldsValue({receiverPhone:this.receiverPhone})

        });

        }else{
                this.$message.warning(res.message);
              }

      }).finally(() => {
              // that.confirmLoading = false;
              // that.checkedDepartNames = [];
              // that.userDepartModel.departIdList = {userId:'',departIdList:[]};

              // that.close();
            })
      },
      sendOutOk(){
        this.form.validateFields((err, values) => {
          if (!err) {


            // let courseCoverFile = this.courseCoverFile;

            let valuesParam = {};
            valuesParam = {...values,id:this.id};

            sendGoods(valuesParam).then((res)=>{
              if(res.success==true){
                this.$message.success(res.message,()=>{
                  this.$router.push({ path:'/mallManage/orderList'});
                });
                
              }else{
                this.$message.warning(res.message);
              }

            }).finally(() => {
              // that.confirmLoading = false;
              // that.checkedDepartNames = [];
              // that.userDepartModel.departIdList = {userId:'',departIdList:[]};

              // that.close();
            })


          }
        })
      },
      
    },
    created() {
      this.orderNo = this.$route.query.orderNo;
      this.id = this.$route.query.id;
     this.getOrderById();
      // this.form.setFieldsValue({orderNo:this.orderNo})
      this.$nextTick(() => {
        this.form.setFieldsValue({orderNo:this.orderNo})

      });
    },
  }
</script>
<style scoped>
  @import '~@assets/less/common.less';
</style>
<style lang="scss" scoped >
  .course-create-wrap{
    .info-title{
      border-bottom: 1px solid #E7ECEF;
      line-height: 50px;
      height: 50px;
      padding-left: 25px;
    } 

    .info-content{
      .img-tip{
        color: #999999;
        font-size: 12px;
      }
      .ant-upload-list-picture-card{
        .ant-upload-list-item{
          width:142px!important;
          height:80px;
        }
      }
      .j-teacher-list{
        .j-teacher-item{
          border: 1px solid #D0DBE4;
          padding: 20px;
          .j-teacher-item-con{
            width: 587px;
            overflow: hidden;
            .j-teacher-item-upload{
              width: 90px;
              float: left;
              .ant-upload-select-picture-card{
                width: 80px;
                height:80px;
              }
            }
            .j-teacher-item-ctx{
              margin-left:90px;
            }
          }
          
        }
      }
      .kaike-tip{
        color:#FA6400;
        font-size: 12px;
        // line-height: 1;
      }
      .kaike-radio-list{
        line-height: 1;
        .kaike-radio-item{
          line-height: 1;
          margin-bottom: 12px;
          margin-top: 0px;
        }
      }
      
    }

    
  }
  

</style>